import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/2a2ba5ce/node_modules/@undataforum/gatsby-theme-base/src/components/mdx-page.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`By accessing this site, certain information about the User, such as Internet
protocol (IP) addresses, navigation through the Site, the software used and the
time spent, along with other similar information, will be collected and stored
on third party servers. These will not specifically identify the User.`}</p>
    <p>{`The information will be used internally only for web site traffic analysis. If
the User provides unique identifying information, such as name, address and
other information on forms stored on this Site, such information will be used
only for statistical purposes and will not be published for general access. The
United Nations, however, assumes no responsibility for the security of this
information.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      